import React from 'react';

const TermsPage = () => {
  return (
    <div className="legal-page">
      <h1>Terms and Conditions</h1>
      <p><strong>Effective Date:</strong> 05/01/2025</p>
      <p>
      Welcome to Delinquent Auction, operated by Codeify LLC. 
      By accessing or using this Site, you agree to comply with and be bound by the following Terms and Conditions. 
      If you do not agree with these terms, please do not use our Site.
      </p>
      <h2>1. Use of the Site</h2>
      <p>
        You must be at least 18 years old to use this Site. 
        By registering or using the Site, you represent and warrant that you are at least 18.
      </p>
      <h2>2. Account Registration</h2>
      <p>
        To access certain features of the Site, including subscription content, you must create an account. 
        You agree to provide accurate and complete information during registration and to keep this information up to date.
        You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account.
      </p>
      <h2>3. Subscriptions</h2>
      <p>
        Access to delinquent property leads requires a paid subscription. 
        By subscribing, you authorize us to charge your chosen payment method on a recurring basis until you cancel. 
        You may manage or cancel your subscription through your account settings at any time.
        All fees are non-refundable unless otherwise stated.
      </p>
      <h2>4. Intellectual Property</h2>
      <p>
        All content on the Site, including but not limited to data, text, graphics, and software, is our property or the property of our licensors and is protected by copyright and other intellectual property laws.
        You may not copy, reproduce, modify, distribute, or sell any part of the Site or its content without our express written consent.
      </p>
      <h2>5. Prohibited Activities</h2>
      <p>
        You agree not to:
            <li>* Use the Site for any illegal or unauthorized purpose;</li>
            <li>* Attempt to access or interfere with another user’s account or data;</li>
            <li>* Scrape, data mine, or extract information from the Site for commercial purposes;</li>
            <li>* Share or resell your account or the data obtained through your subscription.</li>
      </p>
      <h2>6. Disclaimer of Warranties</h2>
      <p>
        The Site and all content are provided "as is" without warranty of any kind. 
        We do not guarantee the accuracy, completeness, or usefulness of any information on the Site.
      </p>
      <h2>7. Limitation of Liability</h2>
      <p>
      To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the Site or your inability to access the Site.
      </p>
      <h2>8. Privacy</h2>
      <p>
        We collect and store users' email addresses for account and subscription management purposes. 
        By using the Site, you consent to our collection and use of your information as described in our Privacy Policy.
      </p>
      <h2>9. Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access to the Site at our sole discretion, with or without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
      </p>
      <h2>10. Changes</h2>
      <p>
        We may update these Terms from time to time. 
        If we make material changes, we will notify you by email or through the Site. 
        Your continued use of the Site after such changes constitutes acceptance of the new Terms.
      </p>
      <h2>10. Contact</h2>
      <p>
        Questions? Email us at support@deliquentauction.com
      </p>
    </div>
  );
};

export default TermsPage;
